import React,{useEffect} from 'react'
import { IconButton, Icon, Snackbar, Slide, Alert, styled } from '@material-ui/core'
// import { styled } from '@mui/system'
import { amber, green } from '@material-ui/core/colors'

function TransitionLeft(props) {
    return <Slide {...props} direction="right" />
}
const ContentRoot = styled('div')(({ theme }) => ({
    '& .success': {
        backgroundColor: green[600],
    },
    '& .error': {
        backgroundColor: theme.palette.error.main,
    },
    '& .info': {
        backgroundColor: theme.palette.primary.main,
    },
    '& .warning': {
        backgroundColor: amber[700],
    },
    '& .icon': {
        fontSize: 20,
    },
    '& .iconVariant': {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    '& .message': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .margin': {
        margin: theme.spacing(1),
    },
}))
const CustomSnackbar = ({
    open,
    message,
    duration = 6000,
    horizontal = 'center',
    vertical = 'bottom',
    handleClose,
    variant
}) => {
    useEffect(() => {
        const handleBodyClick = (event) => {
            const snackbar = document.getElementById('custom-snackbar');
            if (snackbar && !snackbar.contains(event.target)) {
                // Click is outside the Snackbar, close it
                handleClose();
            }
        };

        if (open) {
            // Add click event listener when Snackbar is open
            document.body.addEventListener('click', handleBodyClick);
        }

        // Cleanup the event listener when component is unmounted or Snackbar is closed
        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, [open, handleClose]);
    return (
        <ContentRoot>
        <Snackbar
            // anchorOrigin={{
            //     vertical: { vertical },
            //     horizontal: { horizontal },
            // }}
            TransitionComponent={TransitionLeft}
            open={open}
            // autoHideDuration={9000}
            // onClose={handleClose}
            ContentProps={{
                'aria-describedby': 'message-id',
            }}
            // message={<span id="message-id">{message}</span>}
            action={[
                <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    onClick={handleClose}
                >
                    <Icon>close</Icon>
                </IconButton>,
            ]}
            sx={{ width: '96%' }}
        >
            <Alert
                    onClose={handleClose}
                    severity={variant}
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {message}
                </Alert>
        </Snackbar>
        </ContentRoot>
    )
}

export default CustomSnackbar
